import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import integrityImage from "../../../assets/images/about/aboutTheCompany/integrityImage.png"
import excellenceImage from "../../../assets/images/about/aboutTheCompany/excellenceImage.png"
import innovationImage from "../../../assets/images/about/aboutTheCompany/innovationImage.png"
import commitmentImage from "../../../assets/images/about/aboutTheCompany/commitmentImage.png"

interface ImageData {
    src: string;
    text: string;
}

const imageData: ImageData[] = [
    { src: excellenceImage, text: "Excellence" },
    { src: innovationImage, text: "Innovation" },
    { src: integrityImage, text: "Integrity" },
    { src: commitmentImage, text: "Commitment" }

]

const AboutTheCompany = () => {
    return (
        <div className='aboutContainer'>
            <div className='aboutContents'>
                <div className='aboutTitle'>
                    <span>VALUES THAT DEFINE US</span>
                </div>
                <div className='aboutContent'>
                    Our core values shape our approach to construction, ensuring quality, innovation, integrity, and customer satisfaction in every project. We are committed to delivering exceptional craftsmanship and sustainable solutions that withstand the test of time.
                </div>
                <div className='aboutImageContent'>
                    {imageData.map((item, index) => (
                        <div key={index} className='imageTextContainer'>
                            <LazyLoadImage
                                draggable={false}
                                src={item.src}
                                alt={`aboutTheBrand-${index + 1}`}
                                effect="blur"
                                width="230"
                                height="230"
                            />
                            <div>{item.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>



    )
}

export default AboutTheCompany